import { AlertColor } from '@mui/material';
import {
  AnnouncementCategory,
  AnnouncementStatus,
} from '../services/announcementService';

export const categoryToSeverity: Record<AnnouncementCategory, AlertColor> = {
  deploy: 'info',
  patch_critica: 'error',
  manutenzione: 'warning',
};

export const categoryToLabel: Record<AnnouncementCategory, string> = {
  deploy: 'Aggiornamento',
  patch_critica: 'Correzione critica',
  manutenzione: 'Manutenzione',
};

export const statusToLabel: Record<AnnouncementStatus, string> = {
  programmato: 'Programmato',
  in_corso: 'In Corso',
  completato: 'Completato',
};

export const statusToChipColor: Record<
  AnnouncementStatus,
  'warning' | 'info' | 'success'
> = {
  programmato: 'warning',
  in_corso: 'info',
  completato: 'success',
};

export function formatRomeDateTime(iso: string): string {
  return new Date(iso).toLocaleString('it-IT', {
    timeZone: 'Europe/Rome',
    dateStyle: 'short',
    timeStyle: 'short',
  });
}
